import { Chip } from '@mui/material';
import { PAYMENT_STATUS_LABEL, PaymentStatus } from '../../types/payment';

const COLOR: Record<PaymentStatus, 'warning' | 'success' | 'error' | 'default'> = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
  // Reversed: the approval was taken back; outlined so it reads differently from Pending.
  REVERSED: 'default',
};

/** A payment's approval state (Phase 97) — "Pending finance approval",
 * "Approved" or "Rejected" — styled the same on every Finance page. */
export const ApprovalStatusChip = ({ status }: { status: PaymentStatus }) => (
  <Chip size="small" label={PAYMENT_STATUS_LABEL[status]} color={COLOR[status]} variant={status === 'REVERSED' ? 'outlined' : 'filled'} />
);
